module.exports = __webpack_public_path__ + "static/main-a7e7ac6f4b5d467cbbf74260e8fd61db.jpg";